import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";

const FirstDay = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="First Day Guide" 
        description="Everything you need to know for your first day at BlueLux"
      >
        <section className="space-y-6">
          <p>
            Your first day sets the tone for your success. Here's everything you need to know 
            to start strong and make a great impression.
          </p>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Before You Arrive</h2>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Confirm your start time and meeting location with your supervisor</li>
            <li>Ensure your vehicle meets requirements (reliable transportation, adequate cargo space)</li>
            <li>Purchase required uniform items (BlueLux polo shirt, appropriate work attire)</li>
            <li>Bring valid driver's license and proof of vehicle insurance</li>
            <li>Complete Independent Contractor Agreement paperwork</li>
            <li>Review basic pool chemistry fundamentals</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">First Day Schedule</h2>
          <div className="space-y-3 text-muted-foreground">
            <p><strong>8:00 AM - Orientation</strong></p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Sign Independent Contractor Agreement</li>
              <li>Receive equipment, supplies, and testing kit</li>
              <li>Review safety protocols and emergency procedures</li>
              <li>Set up access to digital service reporting system</li>
            </ul>
            
            <p><strong>9:30 AM - Route Assignment</strong></p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Receive your initial route assignment (typically 15-25 pools)</li>
              <li>Review customer details and service histories</li>
              <li>Learn service scheduling and documentation requirements</li>
              <li>Understand compensation structure (base pay + bonuses)</li>
            </ul>
            
            <p><strong>11:00 AM - Field Training Begins</strong></p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Shadow experienced technician on actual service calls</li>
              <li>Observe proper techniques for testing, cleaning, and chemical balancing</li>
              <li>Learn customer interaction best practices</li>
              <li>Practice completing digital service reports</li>
            </ul>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">What to Bring</h2>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Valid driver's license</li>
            <li>Proof of vehicle insurance (minimum coverage required)</li>
            <li>Water bottle (stay hydrated in Southern California heat!)</li>
            <li>Sunscreen and hat for sun protection</li>
            <li>Notepad or phone for taking notes during training</li>
            <li>Smartphone for accessing digital service tools</li>
            <li>Closed-toe, slip-resistant shoes</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">First Week Expectations</h2>
          <p>During your first week, you'll:</p>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Complete shadowing with experienced technician (2-3 days)</li>
            <li>Begin servicing pools under supervision</li>
            <li>Learn BlueLux quality standards and service checklists</li>
            <li>Practice water chemistry testing and adjustments</li>
            <li>Become familiar with your assigned route</li>
          </ul>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default FirstDay;